module.exports = __webpack_public_path__ + "static/img/mark2.f2755da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/markdown/mark2.png
// module id = 0V8t
// module chunks = 0